import { DatePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { DateTime } from 'luxon';
import { Fragment, memo } from 'react';
import ConsulateList from './consulate-list';
import ForeignStateList from 'system/components/shared/foreign-state-list';
import { ForeignStateVM } from 'system/components/shared/foreign-state-list';
import PmiTextField from 'shell/components/shared/text-field';

interface FieldProps {
  value: string;
  error: string;
  touched: boolean;
}

interface DateFieldProps {
  value: DateTime | null;
  error: string;
  touched: boolean;
}

interface FormForeignProps {
  disabled?: boolean;
  isEdit?: boolean;
  foreignState: FieldProps;
  site: FieldProps;
  territory: FieldProps;
  fiscalCode: FieldProps;
  institutionDate: DateFieldProps;
  handleChange: (field: string, value: unknown) => void;
  onChangeForeignState: (foreignState?: ForeignStateVM) => void;
  isChangeName?: boolean;
}

const FormForeignComponent = ({
  disabled = false,
  foreignState,
  site,
  territory,
  fiscalCode,
  institutionDate,
  handleChange,
  onChangeForeignState,
  isChangeName,
}: FormForeignProps): React.ReactElement => {
  return (
    <Fragment>
      <Grid item xs={12} md={3}>
        <ForeignStateList
          value={foreignState.value || ''}
          onChange={(foreignStateSelected) => {
            onChangeForeignState(foreignStateSelected);
          }}
          error={foreignState.touched && Boolean(foreignState.error)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Codice fiscale"
          label="Codice fiscale *"
          id="fiscalCode"
          name="fiscalCode"
          fullWidth
          type="text"
          variant="outlined"
          disabled
          value={fiscalCode.value}
          onChange={(event) => {
            handleChange('fiscalCode', event.target.value);
          }}
          error={fiscalCode.touched && Boolean(fiscalCode.error)}
          helperText={fiscalCode.error}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PmiTextField
          aria-label="Territorio"
          label="Territorio"
          id="territory"
          name="territory"
          fullWidth
          type="text"
          variant="outlined"
          disabled
          value={territory.value}
          onChange={(event) => {
            handleChange('territory', event.target.value);
          }}
          error={territory.touched && Boolean(territory.error)}
          helperText={territory.error}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <ConsulateList
          value={site.value || ''}
          onChange={(event) => handleChange('site', event.target.value)}
          error={site.touched && Boolean(site.error)}
          disabled={disabled}
          codeTerritory={territory.value}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <DatePicker
          label="Data Istituzione"
          value={institutionDate.value || null}
          disabled={isChangeName ? false : disabled}
          onChange={(value) => handleChange('institutionDate', value)}
          minDate={DateTime.fromISO('18000101')}
          renderInput={(params) => (
            <PmiTextField
              id="institutionDate"
              name="institutionDate"
              fullWidth
              {...params}
              error={false}
              helperText=""
            />
          )}
        />
      </Grid>
    </Fragment>
  );
};

FormForeignComponent.displayName = 'Form foreign component';

const FormForeign = memo(FormForeignComponent);

export default FormForeign as typeof FormForeignComponent;
